import { IMenuItem } from "../SideMenu";
import { ISubCategory } from "../sub-elements/SubCategory";

export interface ICategory extends IMenuItem {
  subcategories?: ISubCategory[]
  isSeasonsSwitch?: boolean
}

const menu: ICategory[] = [
  {
    name: "Rule changes",
    id: "changes",
    subcategories: [
      {
        name: "Changes season",
        id: "changes-summary",
        link: "/changes/summary/",
        hideCategoryOnAlphabetical: true,
        alphabeticalCategoryNameAsc: "#",
        alphabeticalCategoryNameDesc: "ZZZ",
        alphabeticalName: "Rule changes season",
      },
    ],
  },
  {
    name: "Introduction",
    id: "introduction",
    subcategories: [
      {
        name: "Football rules",
        id: "simplified-football-rules",
        link: "/introduction/simplified-football-rules/",
        tag: ["rules"],
      },
    ],
  },
  {
    name: "Components & equipment",
    id: "components-equipment",
    subcategories: [
      {
        name: "Pitch",
        id: "pitch",
        elements: [
          {
            name: "Pitch",
            id: "the-pitch",
            link: "/components-equipment/the-pitch/",
            tag: ["pitch"],
          },
          {
            name: "Penalty area",
            id: "penalty-area",
            link: "/components-equipment/penalty-area/",
            tag: ["penalty", "area"],
          },
          {
            name: "Goal area",
            id: "goal-area",
            link: "/components-equipment/goal-area/",
            tag: ["goal", "area"],
          },
          {
            name: "Corner area and corner flags",
            id: "corner-area-and-flags",
            link: "/components-equipment/corner-area-and-flags/",
            tag: ["corner", "area", "flags"],
          },
          {
            name: "Technical area",
            id: "technical-area",
            link: `/components-equipment/technical-area/`,
            tag: ["dug out"],
          },
          {
            name: "Referee review area",
            id: "referee-review-area",
            link: `/components-equipment/referee-review-area/`,
            tag: ["referee", "area"],
          },
        ],
      },
      {
        name: "Goals",
        id: "Goals",
        link: `/components-equipment/goals/`,
        tag: ["goal"],
      },
      {
        name: "Ball",
        id: "Ball",
        link: `/components-equipment/ball/`,
        tag: ["football"],
      },
    ],
  },
  {
    name: "Participants",
    id: "participants",
    subcategories: [
      {
        name: "Players",
        id: "id-players",
        elements: [
          {
            name: "Players & substitutes",
            id: "players",
            link: "/participants/players/",
            tag: ["player", "captains", "goalkeeper"],
          },
          {
            name: "Goalkeepers",
            id: "goalkeepers",
            link: "/participants/goalkeepers/",
            tag: ["player", "captains", "goalkeeper"],
          },
          {
            name: "Captains",
            id: "captains",
            link: "/participants/captains/",
            tag: ["captains"],
          },
          {
            name: "Players' Kit",
            id: "Player-kit",
            link: `/components-equipment/players-kit/`,
            tag: ["equipment", "strip", "shirt"],
          },
        ],
      },
      {
        name: "Coaches & other team officials",
        id: "coaches",
        link: "/participants/coaches-other-team-officials/",
        tag: ["manager", "managers"],
      },
      {
        name: "Referee",
        id: "referee",
        link: "/participants/referee/",
        tag: ["match official", "referee"],
      },
      {
        name: "Other match officials",
        id: "other-officials",
        link: "/participants/other-officials/",
        tag: ["official", "match official", "assistant", "assistant referee", "referee", "referees", "fourth"],
      },
    ],
  },
  {
    name: "Game events",
    id: "game-events",
    subcategories: [
      {
        name: "Playing time",
        id: "playing-times",
        link: `/game-events/playing-times/`,
        tag: [
          "halves",
          "45 minutes",
          "90 minutes",
          "half-time",
          "half-time break",
        ],
      },
      {
        name: "Kick-off",
        id: "kick-off",
        link: `/game-events/kick-off/`,
      },
      {
        name: "Ball in & out of play",
        id: "Ball-in-&-out-of-play",
        link: "/game-events/ball-in-out-of-play/",
        tag: ["dead ball"],
      },
      {
        name: "Corner kick",
        id: "Corner-kick",
        link: "/game-events/corner-kick/",
        tag: ["corner"],
      },
      {
        name: "Dropped ball",
        id: "dropped-ball",
        link: "/game-events/dropped-ball/",
        tag: ["bounce"],
      },
      {
        name: "Goal kick",
        id: "goal-kick",
        link: "/game-events/goal-kick/",
        tag: ["kicking"],
      },
      {
        name: "Throw-in",
        id: "throw-in",
        link: "/game-events/throw-in/",
        tag: ["thrower"],
      },
      {
        name: "Scoring a goal",
        id: "Scoring-a-goal",
        link: `/game-events/scoring-a-goal/`,
        tag: ["goal"],
      },
      {
        name: "Penalties (penalty shoot-out)",
        id: "penalty-shoot-out",
        link: "/game-events/penalty-shoot-out/",
        tag: ["kicks from the penalty mark", "penalties"],
      },
      {
        name: "Winning team",
        id: "winning-team",
        link: "/game-events/winning-team/",
        tag: ["winner"],
      },
      {
        name: "Injuries",
        id: "injuries",
        link: "/game-events/injuries/",
        tag: ["injury time"],
      },
      {
        name: "Substitutions",
        id: "substitutes",
        link: "/game-events/substitutes/",
        tag: ["reserve", "subs", "substitutes", "substitute"],
      },
      {
        name: "Drinks & cooling breaks",
        id: "drinks-cooling-breaks",
        link: "/game-events/drinks-cooling-breaks/",
        tag: ["cool down", "rehydrate", "drinks"],
      },
      {
        name: "Playing distance",
        id: "playing distance",
        link: "/game-events/playing-distance/",
        tag: ["distance"],
      },
    ],
  },
  {
    name: "Offences & sanctions",
    id: "offences-sanctions",
    subcategories: [
      {
        name: "Fouls",
        id: "fouls",
        link: "/offences-sanctions/fouls/",
        tag: ["foul"],
      },
      {
        name: "Handball",
        id: "handball",
        link: "/offences-sanctions/handball/",
        tag: ["hands", "hand"],
      },
      {
        name: "Offside",
        id: "offside",
        link: "/offences-sanctions/offside/",
        tag: ["off"],
      },
      {
        name: "Other offences",
        id: "other-offences",
        elements: [
          {
            name: "Arguing",
            id: "arguing",
            link: "/offences-sanctions/arguing/",
            tag: ["dissent", "protests", "complaint", "protest"],
          },
          {
            name: "Feinting",
            id: "feinting",
            link: "/offences-sanctions/feinting/",
            tag: ["dummying"],
          },
          {
            name: "Insults and abuse",
            id: "insults-and-abuse",
            link: "/offences-sanctions/insults-and-abuse/",
            tag: ["offensive", "insulting", "abusive"],
          },
          {
            name: "Obstruction",
            id: "obstruction",
            link: "/offences-sanctions/obstruction/",
            tag: ["impeding"],
          },
          {
            name: "Simulation",
            id: "id-simulation",
            link: "/offences-sanctions/simulation/",
            tag: ["diving"],
          },
          {
            name: "Other offences",
            id: "other-offences",
            link: "/offences-sanctions/other-offences/",
            tag: [
              "offside offence",
              "verbal offence",
              "simulation",
              "diving",
              "unfair behaviour",
            ],
          },
        ],
      },
      {
        name: "Advantage",
        id: "advantage",
        link: "/offences-sanctions/advantage/",
        tag: [],
      },
      {
        name: "Free kicks",
        id: "free-kicks",
        link: "/offences-sanctions/free-kicks/",
        tag: ["direct free kick", "indirect free kick"],
      },
      {
        name: "Penalty kick",
        id: "penalty-kick",
        link: "/offences-sanctions/penalty-kick/",
        tag: [],
      },
      {
        name: "Cards",
        id: "cards",
        elements: [
          {
            name: "Yellow Cards",
            id: "card-yellow",
            link: "/offences-sanctions/yellow-card/",
            tag: ["send off", "dismiss", "sending off"],
          },
          {
            name: "Red cards",
            id: "red-card",
            link: "/offences-sanctions/red-card/",
            tag: ["send off", "dismiss", "sending off"],
          },
        ],
      },
      {
        name: "Interference on the pitch",
        id: "id-interference",
        elements: [          
          {
            name: "Outside agents",
            id: "outside-agents",
            link: "/offences-sanctions/outside-agents/",
            tag: ["outside agent"],
          },
          {
            name: "Substitutes or team officials",
            id: "substitutes-or-team-officials",
            link: "/offences-sanctions/substitutes-or-team-officials/",
            tag: ["reserve", "subs", "substitutes", "substitute"],
          },
        ],
      },
      {
        name: "Temporary dismissals (sin bins)",
        id: "temporary-dismissals",
        link: "/offences-sanctions/temporary-dismissals/",
        tag: ["sins bins"],
      },
    ],
  },
  {
    name: "Technology",
    id: "technology",
    subcategories: [
      {
        name: "Video Assistant Referee (VAR) system",
        id: "var",
        link: "/technology/var/",
        tag: ["video assistant referee", "var"],
      },
      {
        name: "Goal Line Technology (GLT)",
        id: "goal-line-technology",
        link: "/technology/goal-line-technology/",
        tag: ["glt"],
      },
      {
        name: "Semi-Automated Offside Technology (SAOT)",
        id: "semi-automated-offside-technology",
        link: "/technology/semi-automated-offside-technology/",
        tag: ["saot"],
      },
    ],
  },
  {
    name: "About",
    id: "about",
    subcategories: [
      {
        name: "Laws of the game",
        id: "laws-of-the-game",
        link: "/about/laws-of-the-game/",
        tag: ["laws"],
      },
      {
        name: "Competition rules",
        id: "additional-competition-rules",
        link: "/about/additional-competition-rules/",
        tag: ["rules"],
      },
    ],
  },
  {
    name: "PDF downloads",
    id: "pdf-downloads",
    subcategories: [
      {
        name: "PDF by category",
        id: "pdf-by-category",
        link: '#',
        tag: ["pdf"],
      },
      {
        name: "PDF A-Z",
        id: "pdf-a-z",
        link: '#',
        tag: ["pdf"],
      },
    ],
  },
]

export default menu
